import { API } from "aws-amplify";
import { atom, selector } from "recoil";
import { API as graphAPI, graphqlOperation } from "aws-amplify";
import { listSchemes } from "../graphql/queries";
import { getSchemeForAdmin } from "../graphql/queries-custom";
import { getErrorMessage } from "../helpers/Error";

export const schemesAtom = atom({
	key: "schemesAtom",
	default: null,
});

export const schemesSelector = selector({
	key: "schemesSelector",
	get: async () => {
		const {
			data: {
				listSchemes: { items: schemes },
			},
		} = await graphAPI.graphql(graphqlOperation(listSchemes));

		return schemes;
	},
	set: ({ set }, newValue) => {
		set(schemesAtom, newValue);
	},
});

export const selectedSchemeAtom = atom({
	key: "selectedSchemeAtom",
	default: null,
});

export const selectedSchemeSelector = selector({
	key: "selectedSchemeSelector",
	get: async ({ get }) => {
		let scheme = null;
		const selectedScheme = get(selectedSchemeAtom);

		if (selectedScheme) {
			try {
				const {
					data: { getScheme: schemeData },
				} = await API.graphql(
					graphqlOperation(getSchemeForAdmin, {
						id: selectedScheme.id,
					}),
				);

				if (!schemeData) {
					throw new Error("Scheme not found");
				}

				const contact = parseContactField(schemeData.contact);
				const contactEmergency = parseContactField(schemeData.contactEmergency);

				scheme = {
					...schemeData,
					users: schemeData.users ?? { items: [] },
					contact,
					contactEmergency,
				};
			} catch (err) {
				throw new Error(getErrorMessage(err));
			}
		}
		return scheme;
	},
});

const parseContactField = (value) => {
	if (value === null || value === undefined || value === "") {
		return normaliseContact();
	}

	if (typeof value === "object") {
		return normaliseContact(value);
	}

	if (typeof value !== "string") {
		return normaliseContact();
	}

	try {
		const parsed = JSON.parse(value);
		if (parsed && typeof parsed === "object") {
			return normaliseContact(parsed);
		}
	} catch {
		return normaliseContact();
	}

	return normaliseContact();
};

const normaliseContact = (contact = {}) => ({
	name: normaliseContactValue(contact?.name),
	phone: normaliseContactValue(contact?.phone),
	email: normaliseContactValue(contact?.email),
});

const normaliseContactValue = (value) => {
	if (value === null || value === undefined) {
		return "";
	}

	if (typeof value === "number") {
		return value > 0 ? String(value) : "";
	}

	if (typeof value === "string") {
		const trimmed = value.trim();
		return trimmed === "0" ? "" : trimmed;
	}

	return "";
};
